import Close from "@mui/icons-material/Close";
import React, { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../Modal";

import styles from "./RenameModal.module.scss";

const RenameModal = (props) => {
  const { open, onClickClose, onRename, oldName = "" } = props;
  const { t } = useTranslation();

  const [name, setName] = useState("");

  //Initialise the text box with the current name
  useEffect(() => {
    setName(oldName);
  }, [oldName]);

  return (
    <Modal show={open} className={styles.modal} closeModal={onClickClose}>
      <Close className={styles.closeIcon} onClick={onClickClose} />
      <div className={styles.container}>
        <h4 className={styles.title}>{t("rename.rename_design")}</h4>
        <div className={styles.inviteDiv}>
          <form
            className={styles.renameForm}
            onSubmit={(e) => {
              e.preventDefault();
              onRename(name);
            }}
          >
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={styles.input}
            />
            <input
              type="submit"
              className={styles.button}
              value={t("rename.rename")}
            />
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default RenameModal;
